import { trackEvent } from '../../../_common/client/tracking';

export const trackDimensionSwipes = (tilesContainer: HTMLElement) => {
    const dimensionType = tilesContainer.getAttribute('data-dimension-type')?.split(' ')[0];
    if (!dimensionType) return;
    tilesContainer.addEventListener('touchend', () => {
        trackEvent({ product_DimensionSwipe: dimensionType });
    });
};
